import React, { useEffect, useState } from "react";
import addDocSvg from 'assets/images/addDocSvg.svg';
import screenPng from "assets/images/screenshop.png";
import Layout from "../components/Layout/Layout";
import FormChangePassword from "./components/FormResetPassword/FormChangePassword";
import { useNavigate, useParams } from "react-router-dom";
import { useVerifyTokenResetPassword } from "../../../services/auth/querys";
import { Button } from "antd";
import { useSendEmailResetPassword } from "../../../services/auth/mutations";
import ModalBasic from "../../../components/Organisms/Modals/ModalBasic/ModalBasic";
import homeImg from '../../../assets/images/home-svg.jpg';
import { decodeJWT } from "../../../@common/utils/jwt";
import "./ChangePassword.scss";
import { BORROWER_ONBOARDING_URL } from "@common/config/environments";

const ChangePassword = () => {

  const navigate = useNavigate();
  let { token }: any = useParams();

  const { execute: sendEmailResetPassword } = useSendEmailResetPassword();
  const { data: isVerifyToken, fetching } = useVerifyTokenResetPassword({ variables: { token } });

  const [modalConfirmEmail, setModalConfirmEmail] = useState<boolean>(false);
  const [ready, setReady] = useState<boolean>();
  const [userEmail, setUserEmail] = useState<string>('');

  useEffect(() => {
    if (token) {
      const decodedToken = decodeJWT(token);
      if (decodedToken && decodedToken.email) {
        setUserEmail(decodedToken.email);
      }
    }
  }, [token]);

  const onReadyResetPassword = () => {
    setReady(true);
  }

  const redirectSignIn = () => {
    //COPIADO DEL BarDashboard
    localStorage.removeItem('token');
    window.dispatchEvent(new Event("storage"));
    navigate("/login?changePassword=true");
    navigate(0);
  }

  const onSendEmailResetPassword = () => {
    if (isVerifyToken === false) {
      navigate('/reset-password');
      return;
    }
    sendEmailResetPassword();
    setModalConfirmEmail(true);
  }

  if (fetching)
    return null;

  return (
    <Layout>
      <div className="Login view-change-password">
        <div className="Login-colum"></div>
        {ready &&
          <div className="Login-form Login-form--width-50" >
            <h1 className="h1">Your password has been updated!</h1>
            <p className="description">Click below to sign in with your new password</p>
            <Button className="button button-primary button-txt-big" onClick={redirectSignIn}>
              Sign in
            </Button>
          </div>
        }
        {!ready && isVerifyToken &&
          <div className="Login-form">
            <div className="Login-form-container">
              <h1 className="h1">Set a new password</h1>
              <p className="description">
                This will update the password
                <br />
                <b>{userEmail}</b>
              </p>
            </div>
            <FormChangePassword onReady={onReadyResetPassword} handlerRedirectSignIn={redirectSignIn} />
            <a
              className="body-regular link-absolute"
              href={`${BORROWER_ONBOARDING_URL}/`}
              rel="noopener noreferrer"
            >
              Don&apos;t have an account?{" "}
              <span className="body-regular-bold">Price your first loan</span>
            </a>
          </div>
        }
        {!ready && !isVerifyToken &&
          <div className="Login-form Login-form--width-50">
            <h1 className="h1">Oops! That link is expired.</h1>
            <p className="description">If you&apos;d still like to change your password, you&apos;ll need to generate a new link.</p>
            <Button className="button button-primary button-txt-big" onClick={onSendEmailResetPassword}>
              Reset Password
            </Button>
          </div>
        }
        <div className="right">
          <div className="content">
            <div>
              <img className="star" src="https://storage.googleapis.com/constlending-borrowers/static/star-vector.svg" />
            </div>
            <p className="phrase">
              &quot;Dealing with multiple lenders is exhausting and wondering if I&apos;d get financing made me apprehensive about chasing deals. Thanks to you, I can just focus on buying properties!&quot;
            </p>
            <div className="author">
              <b>Chandra M</b>
              <br></br>
              Real estate investor
            </div>
          </div>
          <div>
            <img className="home" src={homeImg} />
          </div>
        </div>
      </div>

      <ModalBasic
        visible={modalConfirmEmail}
        setVisible={setModalConfirmEmail}
        title='Check your email'
        description={'We sent you instructions on how to reset your password. Please follow the link in the email to create a new password.'}
        submit={{ buttonLabel: 'OK!', onSubmit: () => setModalConfirmEmail(false) }}
      />
    </Layout>
  );
};
export default ChangePassword;